<template lang="pug">
  .rankTable-wrapper
    table.rankTable
      tr
        th(v-for="(row, key) of filteredList[0]", v-if="key!=='game_seq'")
          span.report-col {{getTranslate(key)}}
      tr(v-for="item in filteredList", :class="{active: (item.player === $route.query.playerId) && $route.query.playerId !== undefined}", :key="item.player + '-' + item.no")
        td(v-for="(row, key) of item")
          span(v-if="key === 'player'") {{formatId(row)}}
          span(v-else-if="key === 'score'")
            div {{row.score}}
          span(v-else-if="key === 'turnover'")
            div {{row | formatNumber}}
          span(v-else) {{row}}
    .more(v-if="preferLength > 20")
      button.moreBtn(href='javascript:;', @click.stop.prevent="toggleMore") {{showMore ? '看前 20 名' : '查看更多'}}
</template>

<script>
import numeral from 'numeral'
export default {
  props: ['list', 'preferLength'],
  data () {
    return {
      showMore: false
    }
  },
  created () {
  },
  filters: {
    dateFormat: (date) => {
      let format = date.split('/')
      format.shift()
      return format.join('/')
    },
    formatNumber: (val) => {
      if (val) return numeral(val).format('$0,0.00')
      else return ''
    }
  },
  methods: {
    toggleMore () {
      this.showMore = !this.showMore
    },
    formatId (val) {
      if (val) {
        let restructure = val.split('@')[0].split('')
        return '**' + restructure.slice(((3 - restructure.length) * -1), restructure.length).join('')
      }
    },
    getTranslate (val) {
      let translation = {
        no: '名次',
        player: '玩家帐号',
        score: '捕获次数',
        turnover: '累积押码'
      }
      return translation[val] || val
    }
  },
  computed: {
    fullfilledList () {
      let fullList = []
      if (this.list.length < this.preferLength) {
        fullList = this.list.slice()
        for (let i = 0; i < this.preferLength - this.list.length; i++) {
          let template = Object.assign({}, this.list[0])
          for (let col in template) {
            template[col] = ''
          }
          template['no'] = this.list.length + 1 + i
          fullList.push(template)
        }
      } else {
        fullList = this.list.slice()
      }
      return fullList
    },
    filteredList () {
      if (this.showMore) {
        return this.fullfilledList.slice()
      } else {
        return this.fullfilledList.slice(0, 20)
      }
    }
  }
}
</script>

<style lang="scss">
@import '~breakpoint-sass/stylesheets/_breakpoint';

// #universalParser{
//   background: transparent;
//   padding: 0 10px 10px;
//   font-size: 1.5rem;
//   .game{
//     background: hsla(0, 0, 100%, 0.8);
//     border-radius: 15px;
//   }
//   h3{
//     color: white;
//   }
// }
td {
  &.left {
    text-align: left;
  }
  &.right {
    text-align: right;
  }
}

.line-btn{
  margin: 0 auto;
  border-bottom: 1px solid white;
  @include breakpoint(524px){
    width: 50%;
  }
}

.report-col{
  width: 20%;
}
.report-icon{
  display: block;
  height: 20px;
  overflow: hidden;
  @include breakpoint(325px){
    height: 29px;
  }
  @include breakpoint(380px){
    height: 45px;
  }
}
.game_icon {
  width: 50%;
  @include breakpoint(1024px){
    width: 40%;
  }
  @include breakpoint(1200px){
    width: 35%;
  }
}
#universalParser {
  margin-bottom: 350px;
}
.dialog-wrapper{
  /*防止長按選取文字*/
  -ms-touch-action: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  position: fixed;
  background: hsla(0, 0, 0, 0.8);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  // justify-content: space-around;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: black;
  .dialog-content{
    width: 80%;
    height: 90%;
    overflow-x: hidden;
    // background: #000 url('../assets/images/dialog-bg.jpg') no-repeat fixed center;
    // box-shadow: 0 0 40px 15px #950802;
    // border-radius: 10px;
    // border: 8px ridge #fe7f0f;
    padding: 0 10px 10px;
    background: #f7f7f7;
    @include breakpoint(1366px) {
      width: 70%;
    }
    .dialog-title{
      text-align: center;
      font-size: 3rem;
    }
    .dialog-content{
      width: 100%;
    }
  }
  .dialog-close {
    width: 80%;
    padding: 0 10px;
    position: relative;
    @include breakpoint(1366px) {
      width: 70%;
    }
  }
  .close-btn{
    width: 50px;
    height: 50px;
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    z-index: 999;
    background: url('../assets/images/close.svg') no-repeat right center;
    background-size: 50px 50px;
    opacity: 0.8;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/rankTable.vue